import styled, { css } from 'styled-components';
import theme from '../theme';

const variantStyles = {
  success: css`
    background: ${theme.colors.successLight};
    color: ${theme.colors.success};
  `,
  warning: css`
    background: ${theme.colors.warningLight};
    color: ${theme.colors.warning};
  `,
  danger: css`
    background: ${theme.colors.dangerLight};
    color: ${theme.colors.danger};
  `,
  info: css`
    background: ${theme.colors.infoLight};
    color: ${theme.colors.info};
  `,
  neutral: css`
    background: ${theme.colors.background};
    color: ${theme.colors.textSecondary};
  `,
  primary: css`
    background: ${theme.colors.primaryGhost};
    color: ${theme.colors.primary};
  `,
};

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: ${theme.radii.full};
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.tiny.size};
  font-weight: 600;
  white-space: nowrap;
  line-height: 1.4;

  ${({ $variant = 'neutral' }) => variantStyles[$variant] || variantStyles.neutral}
`;

export default Badge;
